<template>
    <div class="print-well-score-metrics">
        <well-rank :well="focusedWell" />
        <kid-score :well="focusedWell" :only-background-high-score="true" />
        <blast-score :well="focusedWell" :only-background-high-score="false" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import WellRank from '../common/WellRank'
import KidScore from '../score-metrics/KidScore'
import BlastScore from '../score-metrics/BlastScore'

export default {
    name: 'PrintWellScoreMetrics',
    components: { BlastScore, KidScore, WellRank },
    computed: {
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        })
    }
}
</script>

<style lang="scss" >
.print-well-score-metrics {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 10px;
    width: 250px;
    margin-block: 1rem;

    > * {
        aspect-ratio: 1;
    }

    .well-rank {
        background-color: $white !important;
        border: 1px solid $light-alpha;

        .title {
            color: $black !important;
        }
        .value {
            color: $black !important;
            font-size: 1.5rem !important;
        }
        .crown {
            display: none;
        }
    }
    .kid-score {
        background-color: $white !important;
        border: 1px solid $light-alpha !important;

        .label {
            color: $black !important;
        }
        .value {
            color: $black !important;
            font-weight: bold;
            font-size: 1.5rem !important;
        }
    }
    .blast-score {
        background-color: $white !important;
        border: 1px solid $light-alpha;

        .label {
            color: $black !important;
        }
        .value {
            color: $black !important;
            font-weight: bold;
            font-size: 1.5rem !important;
        }
    }
}
</style>
